<template>
  <v-col justify="space-around">
    <div v-if="dataType === 1">
      <v-dialog
        ref="dialog1"
        v-model="modal1"
        :return-value.sync="picker1"
        persistent
        width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="picker1"
            label="start date"
            prepend-icon="event"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker v-model="picker1" :min="mindate" :max="maxdate" scrollable>
          <div class="flex-grow-1"></div>
          <v-btn depressed text color="primary" @click="modal1 = false">
            Cancel
          </v-btn>
          <v-btn depressed text color="primary" @click="$refs.dialog1.save(picker1)">
            OK
          </v-btn>
        </v-date-picker>
      </v-dialog>
      <v-dialog ref="dialog" v-model="modal" :return-value.sync="picker" persistent width="290px">
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="picker"
            label="end date"
            prepend-icon="event"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker v-model="picker" :min="mindate" :max="maxdate" scrollable>
          <div class="flex-grow-1"></div>
          <v-btn depressed text color="primary" @click="modal = false">
            Cancel
          </v-btn>
          <v-btn depressed text color="primary" @click="$refs.dialog.save(picker)">
            OK
          </v-btn>
        </v-date-picker>
      </v-dialog>
    </div>
    <div v-if="dataType === 2">
      <v-select
        :value="DFTYearSelected"
        :items="yearRange"
        label="Year"
        solo
        @input="inputDFTYearSelected"
      ></v-select>
    </div>
    <div v-if="dataType === 3">
      <v-select
        :value="bigCountYearSelected"
        :items="yearRange"
        label="Year"
        solo
        @input="inputBigCountSelected"
      ></v-select>
    </div>
    <v-divider />
    <v-card-actions>
      <v-spacer />
      <v-btn depressed large color="primary" rounded @click="loadData">
        Load
      </v-btn>
    </v-card-actions>
  </v-col>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';

export default {
  name: 'Datepicker',
  props: {
    yearRange: {
      type: Array,
      default: () => ['2017', '2016', '2015', '2014', '2013', '2012'],
    },
    dataType: {
      type: Number,
      default: 1,
    },
  },
  data: () => ({
    picker: new Date().toISOString().substr(0, 10),
    picker1: new Date('2019-01-01').toISOString().substr(0, 10),
    modal: false,
    modal1: false,
    mindate: new Date('2019-01-01').toISOString().substr(0, 10),
    maxdate: new Date().toISOString().substr(0, 10),
  }),
  computed: {
    DFTYearSelected: {
      get() {
        return this.getDFTYearSelected();
      },
      set() {
        return null;
      },
    },
    bigCountYearSelected: {
      get() {
        return this.getBigCountYearSelected();
      },
      set() {
        return null;
      },
    },
  },
  mounted() {
    this.DFTYearSelected = this.getDFTYearSelected();
    this.bigCountYearSelected = this.getBigCountYearSelected();
  },
  methods: {
    ...mapActions(['fetchLiveCounter', 'fetchDFTDataset', 'fetchBigCountDataset']),
    ...mapMutations(['setDFTYearSelected', 'setBigCountSelected']),
    ...mapGetters(['getDFTYearSelected', 'getBigCountYearSelected']),
    loadData() {
      switch (this.dataType) {
        case 2:
          this.fetchDFTDataset();
          break;
        case 3:
          this.fetchBigCountDataset();
          break;
        default:
          this.fetchLiveCounter({ picker: this.picker, picker1: this.picker1 });
      }
    },
    inputDFTYearSelected(val) {
      this.setDFTYearSelected(val);
    },
    inputBigCountSelected(val) {
      this.setBigCountSelected(val);
    },
  },
};
</script>
